/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React, {
    useEffect, useRef, useState,
} from 'react';
import Slider from 'react-slick';
import { makeStyles } from '@material-ui/core';
import {
    any,
    arrayOf, bool, func, node, number, oneOfType, shape, string,
} from 'prop-types';
import SlickCSSWrapper from './SlickCSSWrapper';
// import SliderArrow from './SliderArrow';

const useStyles = (props) => makeStyles((theme) => ({
    sliderContainer: {
        width: '100%',
        '& .slick-track': {
            display: 'flex',
            padding: '10px 0',
        },
        '& .slick-current': {
            [theme.breakpoints.down(props.breakpointMobile)]: {
                transform: 'scale(1)',
            },
        },
        '& .slick-slide': {
            padding: '0 10px',
            width: props.slideWithStyle,
            minWidth: props.slideWithStyle,
            maxWidth: props.slideWithStyle,
            height: 'auto',
            transition: '500ms ease-in',
            '& > div': {
                height: '100%',
            },
            [theme.breakpoints.down(props.breakpointMobile)]: {
                padding: '0 5px',
                transform: props.middleMode,
            },
            // [theme.breakpoints.down(props.slideWidth)]: {
            //     minWidth: 'calc(100vw - 190px);',
            //     maxWidth: 'calc(100vw - 190px);',
            // },
            '& img': {
                width: '100%',
                display: 'inline-block',
            },
            '& MuiCard-root': {
                boxShadow: 'none',
            },
        },
        '& > p': {
            display: 'none',
            textAlign: 'center',
            color: '#2F2F2F',
            fontSize: '1.2rem',
            [theme.breakpoints.down(props.breakpointMobile)]: {
                fontSize: '14px',
                display: 'block',
            },
        },
    },
    sliderCenter: {
        '& .slick-track': {
            justifyContent: 'center',
        },
    },

}));

function CustomSlider({
    children, length, slideWidth, breakpointMobile, parentClass, refProp, showIndex, middleMode,
}) {
    const classes = useStyles({
        slideWidth, slideWithStyle: `${slideWidth}px`, breakpointMobile, middleMode: middleMode ? 'scale(0.88)' : 'scale(1)',
    })();

    if (typeof window === 'undefined') return null;

    const [slideIndex, setSlideIndex] = useState(1);
    const [initialSlide, setInitialSlide] = useState(false);
    const [updateCount, setUpdateCount] = useState({ current: 0, next: 0 });
    const [slidesShowing, setSlidesShowing] = useState(length);
    const [windowInnerWidth, setWindowInnerWidth] = useState(window.innerWidth);
    const sliderContainer = useRef(null);
    const sliderRef = useRef(null);

    const handleSlidesShowing = () => {
        if (windowInnerWidth <= breakpointMobile && !initialSlide) {
            setSlideIndex(1);
            setInitialSlide(true);
        }
        if (windowInnerWidth > breakpointMobile) setInitialSlide(false);
        if (!sliderContainer?.current) return;
        const element = sliderContainer.current;

        const slidesToShow = Math.floor(element.clientWidth / slideWidth);

        if (slidesToShow <= 1) {
            setSlidesShowing(1);
        } else if (slidesToShow >= length) {
            setSlidesShowing(length);
        } else setSlidesShowing(slidesToShow);
    };

    const handleResize = () => {
        setWindowInnerWidth(window.innerWidth);
    };

    const handleRightSwipe = () => {
        if (slideIndex === length) return setSlideIndex(1);
        return setSlideIndex(slideIndex + 1);
    };

    const handleLeftSwipe = () => {
        if (slideIndex === 1) return setSlideIndex(length);
        return setSlideIndex(slideIndex - 1);
    };

    useEffect(() => {
        const nextSlide = updateCount.next;
        const currentSlide = updateCount.current;
        let direction;
        if (Math.abs(nextSlide - currentSlide) === 1) {
            direction = (nextSlide - currentSlide > 0) ? 'right' : 'left';
        } else {
            direction = (nextSlide - currentSlide > 0) ? 'left' : 'right';
        }
        if (direction === 'right') handleRightSwipe();
        if (direction === 'left') handleLeftSwipe();
    }, [updateCount]);

    useEffect(() => { handleSlidesShowing(); }, [windowInnerWidth]);

    useEffect(() => {
        handleSlidesShowing();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div ref={sliderContainer} className={`${classes.sliderContainer} ${parentClass !== '' ? parentClass : ''} ${(slidesShowing === length) && classes.sliderCenter}`}>
            <SlickCSSWrapper>
                <Slider
                    dots
                    // centerMode
                    infinite
                    speed={500}
                    easing="ease-in"
                    focusOnSelect
                    slidesToShow={slidesShowing}
                    slidesToScroll={1}
                    variableWidth
                    ref={refProp || sliderRef}
                    beforeChange={(current, next) => setUpdateCount({ current, next })}
                    // nextArrow={<SliderArrow sliderRef={refProp || sliderRef} direction="right" />}
                    // prevArrow={<SliderArrow sliderRef={refProp || sliderRef} direction="left" />}
                    arrows={false}
                >
                    {children}
                </Slider>
            </SlickCSSWrapper>
            {showIndex && <p>{slideIndex} of {length}</p>}
        </div>
    );
}

CustomSlider.defaultProps = {
    slideWidth: 300,
    breakpointMobile: 800,
    parentClass: '',
    refProp: null,
    showIndex: true,
    middleMode: true,
};

CustomSlider.propTypes = {
    refProp: oneOfType([
        func,
        shape({ current: any }),
    ]),
    children: oneOfType([
        arrayOf(node),
        node,
    ]).isRequired,
    length: number.isRequired,
    slideWidth: number,
    breakpointMobile: number,
    parentClass: string,
    showIndex: bool,
    middleMode: bool,
};

export default CustomSlider;
